<template>
  <div class="page-header">
    <div class="title-wrapper">
      <h2 class="title" :style="{ color: tonal?.white.white }">
        {{ props.title }}
      </h2>
    </div>

    <div class="side-filter-section">
      <div
        v-for="(filter, index) in filterList"
        :key="filter.key"
        class="custom-select"
      >
        <div
          class="field"
          :style="{
            backgroundColor: tonal.gray[700],
          }"
        >
          <div class="text">
            <span
              :style="{
                color: tonal.white.white,
              }"
            >
              {{ selectedValueListComp[index].title }}
            </span>
          </div>

          <div class="append-icon">
            <arrow-icon :color="tonal.gray[200]" :width="'38px'" />
          </div>
        </div>

        <select
          :value="selectedValueListComp[index].value"
          :style="{
            color: tonal.gray[200],
          }"
          @change="
            handleSelected({ key: filter.key, value: $event.target.value })
          "
        >
          <option
            v-for="option in filter?.itemList ?? []"
            :key="option.value"
            :value="option.value"
          >
            {{ option.title }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { tonal } from '@/constants/tonal'

  import ArrowIcon from '@/components/category/Sub/Header/icon/ArrowDown'

  const props = defineProps({
    title: {
      type: String,
      default: '',
    },
    filterList: {
      type: Array,
      default: () => [],
    },
    filterValues: {
      type: Object,
      default: () => ({}),
    },
  })

  const emit = defineEmits(['changeFilter'])

  const selectedValueListComp = computed(() => {
    return props.filterList?.map((filter) => {
      const defaultValue = filter._default
      const selectedValue = props.filterValues[filter.key] ?? defaultValue
      return filter.itemList.find((item) => item.value === selectedValue)
    })
  })

  const handleSelected = (event) => {
    if (event) {
      emit('changeFilter', { key: event.key, value: event.value })
    }
  }
</script>

<style scoped lang="scss">
  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 78px 0 22px 0;

    .title {
      font-size: 24px;
      font-weight: 400;
      line-height: 36px;
      &::after {
        display: none;
      }
    }
  }

  .side-filter-section {
    display: flex;
    align-items: center;
    .custom-select {
      position: relative;
      user-select: none;
      min-width: 210px;
      margin-left: 10px;
      .field {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        .text {
          flex-basis: 100%;
          padding: 8px 0 8px 20px;

          span {
            display: block;
            line-height: 24px;
            width: 100%;

            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }

        .append-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          transition: transform 0.15s ease-in-out;
        }
      }

      select {
        appearance: none;
        -webkit-appearance: none;
        border: unset;
        outline: none;
        cursor: pointer;
        background-color: transparent;
        font-size: 0;
        padding: 0;

        position: absolute;
        width: 100%;
        height: 100%;
        right: 0;
        top: 0;
      }
    }
  }
</style>
